var map = {
	"./DROP_DOWN.svg": 364,
	"./ic_arbitrum_16.svg": 905,
	"./ic_avalanche_16.svg": 906,
	"./ic_avax_40.svg": 543,
	"./ic_bnb_40.svg": 544,
	"./ic_btc_40.svg": 398,
	"./ic_coingecko_16.svg": 907,
	"./ic_convert_down.svg": 908,
	"./ic_copy_16.svg": 909,
	"./ic_eth_40.svg": 399,
	"./ic_frax_40.svg": 545,
	"./ic_glp_24.svg": 546,
	"./ic_glp_40.svg": 547,
	"./ic_link_40.svg": 548,
	"./ic_metamask_16.svg": 910,
	"./ic_mim_40.svg": 549,
	"./ic_new_link_16.svg": 911,
	"./ic_settings_16.svg": 912,
	"./ic_sign in_16.svg": 913,
	"./ic_sign_out_16.svg": 914,
	"./ic_uni_40.svg": 550,
	"./ic_usdc.e_40.svg": 551,
	"./ic_usdc_40.svg": 552,
	"./ic_usdt_40.svg": 553,
	"./ic_wavax_40.svg": 554,
	"./ic_wbnb_40.svg": 555,
	"./ic_weth_40.svg": 556,
	"./lever.svg": 915,
	"./long.svg": 916,
	"./short.svg": 917,
	"./swap.svg": 918,
	"./swapup.svg": 919,
	"./wave-01.png": 920
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 904;